import { PageMeta } from '@utils/pages';

export const meta: PageMeta = {
  listed: false,
  staffOnly: true,
};
